import { defineStore } from 'pinia';

import type {
  ActivitySelectionCardData,
  ActivitySelectionListData,
} from '../../models';

export const useActivitySelectionListStore = defineStore(
  'ActivitySelectionListStore',
  () => {
    // State
    const isFirstActivitySelectionListRender = true;

    // Actions
    function getFormattedData(
      data: ActivitySelectionCardData[]
    ): ActivitySelectionListData[] {
      const result: ActivitySelectionListData[] = [];
      data.forEach((item, index) => {
        result.push({ data: item, id: index });
      });
      return result;
    }

    return {
      // State
      isFirstActivitySelectionListRender,

      // Actions
      getFormattedData,
    };
  }
);
